<template>
  <el-dialog
    title="登录IP白名单设置"
    :visible.sync="dialogVisible"
    width="520px"
    :show-close="false"
    append-to-body
    :close-on-click-modal="false"
    custom-class="login-ip-whitelist-dialog-shell"
    @closed="onDialogClosed"
  >
    <div class="lip-dialog">
      <section class="lip-section">
        <div class="lip-section-head">
          <span class="lip-section-indicator" aria-hidden="true" />
          <span class="lip-section-title">登录IP验证</span>
        </div>
        <el-radio-group v-model="verifyMode" class="lip-radio-group">
          <el-radio label="0">关闭</el-radio>
          <el-radio label="1">全部开启</el-radio>
          <el-radio label="2">PC</el-radio>
          <el-radio label="3">APP</el-radio>
        </el-radio-group>
      </section>

      <section class="lip-section lip-section--spacing">
        <div class="lip-section-head">
          <span class="lip-section-indicator" aria-hidden="true" />
          <span class="lip-section-title">IP白名单</span>
        </div>
        <div v-for="(row, idx) in ipRows" :key="'lip-ip-' + idx" class="lip-ip-row">
          <el-input v-model="ipRows[idx]" placeholder="请输入IP地址" clearable class="lip-ip-input" @keyup.enter.native="onLastRowEnter(idx)" />
          <button v-if="idx < ipRows.length - 1" type="button" class="lip-row-btn lip-row-btn--minus" title="删除此行" @click="removeIpRow(idx)">
            <i class="el-icon-minus" />
          </button>
          <button v-else type="button" class="lip-row-btn lip-row-btn--plus" title="添加一行" @click="addIpRow">
            <i class="el-icon-plus" />
          </button>
        </div>
        <div class="lip-hint-row" style="justify-content: flex-start; gap: 20px">
          <span class="lip-hint-example">例：172.16.12.0</span>
          <!-- <span class="lip-hint-local">本机IP: {{ maskedLocalIpDisplay }}</span> -->
          <span class="lip-hint-local">本机IP: {{ mine.lastLoginIp }}</span>
        </div>
      </section>
    </div>

    <span slot="footer" class="lip-dialog-footer">
      <el-button class="lip-btn-cancel" @click="close">取消</el-button>
      <el-button type="primary" :loading="btnLoading" :disabled="btnLoading" class="lip-btn-ok" @click="onConfirm">{{
        btnLoading ? "提交中..." : "确定"
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
const IPV4_OR_CIDR = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([0-9]|[12][0-9]|3[0-2]))?$/;

export default {
  name: "LoginIpWhitelistDialog",
  props: {
    mine: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      verifyMode: "0",
      /** 多行输入，至少保留一行 */
      ipRows: [""],
      /** 本机 IP 脱敏展示；若后端提供可在此赋值 */
      localIpMasked: "******",
      btnLoading: false
    };
  },
  computed: {
    maskedLocalIpDisplay() {
      return this.localIpMasked || "******";
    }
  },
  methods: {
    open(payload) {
      if (payload && typeof payload === "object") {
        if (payload.verifyMode != null) this.verifyMode = payload.verifyMode;
        if (Array.isArray(payload.ipList) && payload.ipList.length > 0) {
          this.ipRows = payload.ipList.map((s) => (s != null ? String(s) : ""));
        } else {
          this.ipRows = [""];
        }
        if (payload.localIpMasked != null) this.localIpMasked = payload.localIpMasked;
      } else {
        this.verifyMode = "0";
        this.ipRows = [""];
        this.localIpMasked = "******";
      }
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    onDialogClosed() {
      this.$emit("closed");
    },
    addIpRow() {
      this.ipRows.push("");
    },
    removeIpRow(index) {
      if (this.ipRows.length <= 1) {
        return;
      }
      this.ipRows.splice(index, 1);
    },
    onLastRowEnter(idx) {
      if (idx === this.ipRows.length - 1) {
        this.addIpRow();
      }
    },
    onConfirm() {
      const filled = this.ipRows.map((s) => (s || "").trim()).filter(Boolean);
      const seen = new Set();
      for (let i = 0; i < filled.length; i += 1) {
        const raw = filled[i];
        if (!IPV4_OR_CIDR.test(raw)) {
          this.$message.warning(`请输入有效的 IPv4 或 CIDR：第 ${i + 1} 行「${raw}」`);
          return;
        }
        if (seen.has(raw)) {
          this.$message.warning(`白名单中存在重复 IP：${raw}`);
          return;
        }
        seen.add(raw);
      }
      const data = {
        whitelistType: this.verifyMode,
        ipWhitelist: filled
      };
      this.$emit("confirm", data);
      this.updateIpWhiteList(data);
      // this.close();
    },
    // 调用接口 /user/updateIpWhiteList
    updateIpWhiteList(val) {
      this.btnLoading = true;
      this.$http({
        url: "/user/updateIpWhiteList",
        method: "post",
        data: val
      })
        .then((data) => {
          this.$message.success("操作成功");
          setTimeout(() => {
            this.close();
          }, 500);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.lip-dialog {
  margin-top: -4px;
}

.lip-section {
  &--spacing {
    margin-top: 28px;
  }
}

.lip-section-head {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 16px;
}

.lip-section-indicator {
  width: 4px;
  height: 16px;
  border-radius: 12px;
  background: #003da6;
  flex-shrink: 0;
}

.lip-section-title {
  font-size: 12px;
  font-weight: 400;
  color: #000;
}

.lip-radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;

  ::v-deep .el-radio {
    margin-right: 0;
  }
}

.lip-ip-row {
  display: flex;
  align-items: stretch;
  gap: 10px;

  & + & {
    margin-top: 10px;
  }
}

.lip-ip-input {
  flex: 1;
  min-width: 0;

  ::v-deep .el-input__inner {
    border-radius: 999px;
    height: 40px;
    line-height: 40px;
  }
}

.lip-row-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: #fff;
  cursor: pointer;
  color: #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: color 0.15s;

  &:hover {
    color: #409eff;
  }
}

.lip-hint-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.5;
}

.lip-hint-example,
.lip-hint-local {
  color: #003da6;
}

.lip-dialog-footer {
  display: inline-flex;
  justify-content: flex-end;
  gap: 12px;
}

.lip-btn-cancel {
  border-radius: 8px;
  // padding-left: 22px;
  // padding-right: 22px;
}

.lip-btn-ok {
  border-radius: 8px;
  // padding-left: 22px;
  // padding-right: 22px;
  background-color: #0052d9 !important;
}
</style>

<style lang="scss">
.login-ip-whitelist-dialog-shell.el-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.login-ip-whitelist-dialog-shell .el-dialog__header {
  padding: 18px 22px 12px;
  text-align: left;
}

.login-ip-whitelist-dialog-shell .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.login-ip-whitelist-dialog-shell .el-dialog__body {
  padding: 12px 22px 8px;
}

.login-ip-whitelist-dialog-shell .el-dialog__footer {
  padding: 10px 22px 20px;
  text-align: right;
}
</style>
